var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * MachineExcavator component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconMachineExcavator extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_10750_4767)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M20.2366 20.4856C20.5 20.4856 20.7324 20.2724 20.7324 19.9861C20.7324 19.6998 20.5 19.4866 20.2366 19.4866V18.9856C19.6925 18.9856 19.2324 19.4231 19.2324 19.9861C19.2324 20.549 19.6925 20.9866 20.2366 20.9866V20.4856Z"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M20.236 18.9856C20.7801 18.9856 21.2402 19.4231 21.2402 19.9861C21.2402 20.549 20.7801 20.9866 20.236 20.9866V20.4856C19.9727 20.4856 19.7402 20.2724 19.7402 19.9861C19.7402 19.6998 19.9727 19.4866 20.236 19.4866V18.9856Z"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M11.5677 20.4856C11.831 20.4856 12.0635 20.2724 12.0635 19.9861C12.0635 19.6998 11.831 19.4866 11.5677 19.4866V18.9856C11.0236 18.9856 10.5635 19.4231 10.5635 19.9861C10.5635 20.549 11.0236 20.9866 11.5677 20.9866V20.4856Z"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M11.568 18.9856C12.1122 18.9856 12.5723 19.4231 12.5723 19.9861C12.5723 20.549 12.1122 20.9866 11.568 20.9866V20.4856C11.3047 20.4856 11.0723 20.2724 11.0723 19.9861C11.0723 19.6998 11.3047 19.4866 11.568 19.4866V18.9856Z"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M11.12 7.45419H11.0507C10.5383 7.45419 10.0469 7.65775 9.68453 8.02007C9.32567 8.37894 9.12256 8.86444 9.11871 9.37155L3.99688 4.24972C3.71583 3.96867 3.58075 3.59692 3.59165 3.22869L3.60547 3.1252C3.60982 3.09266 3.61201 3.06032 3.61215 3.02833C3.65978 2.75798 3.78802 2.49904 3.99688 2.29019C4.53798 1.74909 5.41527 1.74908 5.95638 2.29017L11.12 7.45419ZM13.2413 7.45419L7.01708 1.22955C5.89019 0.102655 4.06311 0.102636 2.93622 1.22953C2.41773 1.74802 2.1378 2.41472 2.09643 3.09325L0.52047 14.8949C0.519134 14.9049 0.518002 14.9149 0.51707 14.9248L0.407801 15.2189L0.407027 15.221C0.0860379 16.0927 0.123031 17.056 0.509929 17.9005C0.896827 18.745 1.60219 19.4021 2.47197 19.7283L2.47617 19.7299C3.34788 20.0509 4.31119 20.0139 5.15571 19.627C6.00024 19.2401 6.65735 18.5347 6.98354 17.665L6.98433 17.6629C7.11732 17.305 7.1027 16.9089 6.94369 16.5619C6.78468 16.2148 6.49431 15.9451 6.13644 15.8121L5.35965 15.5234L6.78481 9.15897L9.11866 11.4928L9.11867 17.1219C9.11867 17.1444 9.11966 17.1668 9.12161 17.1888C8.29018 17.838 7.75562 18.8498 7.75562 19.9864C7.75562 21.9455 9.34381 23.5337 11.303 23.5337H20.3462C22.3031 23.5337 23.9 21.9478 23.9 19.9864C23.9 18.8509 23.3648 17.8413 22.5344 17.1923C22.5366 17.1691 22.5377 17.1456 22.5377 17.1219V15.2964C22.5377 14.4705 22.2096 13.6784 21.6256 13.0944C21.0416 12.5104 20.2495 12.1824 19.4236 12.1824H17.6249C17.6008 12.18 17.5763 12.1788 17.5515 12.1788H17.4227L15.5946 8.52197C15.4341 8.20102 15.1873 7.93112 14.882 7.74252C14.5768 7.55397 14.2251 7.45413 13.8663 7.45419H13.2413ZM3.26921 5.64337L5.54461 7.91877C5.52086 7.96864 5.50227 8.02193 5.48969 8.07812L3.94059 14.996L2.11107 14.3161L3.26921 5.64337ZM1.87363 17.2758C1.66051 16.8105 1.63255 16.2825 1.79386 15.7985L5.55612 17.1966C5.36221 17.6685 4.99618 18.0502 4.53097 18.2633C4.04739 18.4848 3.49588 18.5063 2.99659 18.3231C2.49881 18.1358 2.09517 17.7593 1.87363 17.2758ZM15.7457 12.1788L14.2531 9.19297C14.2172 9.1212 14.162 9.06084 14.0937 9.01867C14.0254 8.97649 13.9468 8.95417 13.8665 8.95419H11.0507C10.9361 8.95419 10.8262 8.99971 10.7452 9.08073C10.6642 9.16176 10.6187 9.27165 10.6187 9.38623L10.6187 12.1788L15.7457 12.1788ZM10.6187 13.6788L10.6187 16.3719H21.0377V15.2964C21.0377 14.8683 20.8676 14.4578 20.5649 14.1551C20.2622 13.8524 19.8517 13.6824 19.4236 13.6824H16.9609C16.9364 13.6824 16.912 13.6812 16.8879 13.6788L10.6187 13.6788ZM11.303 17.9391C10.1722 17.9391 9.25562 18.8557 9.25562 19.9864C9.25562 21.1171 10.1722 22.0337 11.303 22.0337H20.3462C21.4792 22.0337 22.4 21.1148 22.4 19.9864C22.4 18.8579 21.4792 17.9391 20.3462 17.9391H11.303Z"
            />
          </g>
          <defs>
            <clipPath id="clip0_10750_4767">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconMachineExcavator.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconMachineExcavator.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconMachineExcavator.prototype, "size", void 0);
if (customElements.get('cat-icon-machine-excavator') === undefined) {
    customElements.define('cat-icon-machine-excavator', BlocksIconMachineExcavator);
}
